import DisplayError from '@/components/layouts/DisplayError'

export default {
  components: { DisplayError }
}
